import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';

const logout = async () => {
  return post(
    API_URLS.LOGOUT,
    {},
    {
      skipGlobalErrorHandler: true,
    },
  );
};

export const useLogout = (): UseMutationResult<AxiosError<{ message?: string; type?: string }>> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: logout,
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
